<template lang="pug">
  .terminal-detail
    .terminal-detail__body

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.cod') }}
        .terminal-detail__item--text
          span {{ itemData.codterm }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.class') }}
        .terminal-detail__item--text
          span {{ itemData.claseterm }}

      .terminal-detail__item
        .terminal-detail__item--text
          ods-checkbox(v-model="checkboxQR" disabled) {{ this.$t('terminalDetail.qr') }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.type') }}
        .terminal-detail__item--text
          span {{ itemData.tipterm }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.descriptionType') }}
        .terminal-detail__item--text
          span {{ itemData.desterm }}

      .terminal-detail__item
        .terminal-detail__item--text
          ods-checkbox(v-model="checkboxDes" disabled) {{ this.$t('terminalDetail.displaced') }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.model') }}
        .terminal-detail__item--text
          span {{ itemData.termred }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.description') }}
        .terminal-detail__item--text
          span {{ itemData.nomterm }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.codCICS') }}
        .terminal-detail__item--text
          span {{ itemData.codcics }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.highDate') }}
        .terminal-detail__item--text
          span {{ itemData.fecalta | formatDateLocale }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.lowDate') }}
        .terminal-detail__item--text
          span {{ itemData.fecbaja | formatDateLocale }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.lowMotive') }}
        .terminal-detail__item--text
          span {{ itemData.desbaja }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.situation') }}
        .terminal-detail__item--text
          span {{ itemData.desindsit }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.instalationDate') }}
        .terminal-detail__item--text
          span {{ itemData.fecinstpv | formatDateLocale }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.lastOperationDate') }}
        .terminal-detail__item--text
          span {{ itemData.fecultope | formatDateLocale }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.owner') }}
        .terminal-detail__item--text
          span {{ itemData.codprop }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.tpvManagement') }}
        .terminal-detail__item--text
          span {{ itemData.desindgtpv }}

      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.tpvSesion') }}
        .terminal-detail__item--text
          span {{ itemData.sesiontpv }}

    .terminal-detail__footer
      ods-divider
      .terminal-detail__item
        .terminal-detail__item--label
          span {{ this.$t('terminalDetail.observations') }}
        .terminal-detail__item--text
          span {{ itemData.dattpv }}

</template>

<script>
export default {
  name: 'TerminalDetail',

  props: {
    data: {
      required: true
    }
  },

  data () {
    return {
      itemData: this.data
    }
  },

  watch: {
    data: {
      immediate: true,
      handler: function (data) {
        Object.keys(data).forEach(key => {
          if (data[key] === null || data[key] === '') {
            data[key] = '-'
          }
        })
        this.itemData = data
      }
    }
  },

  computed: {
    checkboxQR () {
      return this.itemData.indtpvqr === 'S'
    },
    checkboxDes () {
      return this.itemData.indtpvdes === 'S'
    }
  },

  methods: {

  },

  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.terminal-detail {
  &__body {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  &__item {
    margin-bottom: rem(40);
    &--label {
      font-size: rem(12);
      line-height: rem(16);
      color: $--color-neutral-1;
      margin-bottom: rem(8);
    }
    &--text {
      font-size: rem(12);
      line-height: rem(16);
      color: $--color-black;
    }
  }
  &__footer {
    .ods-divider {
      margin-bottom: rem(40);
    }
  }
}
/deep/ .ods-checkbox__input.is-disabled {
  & + span.ods-checkbox__label {
    color: $--color-black;
  }
  &.is-checked .ods-checkbox__inner {
    background-color: $--color-white;
    opacity: 1;
  }
}
</style>
